import {
  buildCoachFastBookOverlayPath,
  COACH_BOOK_STUDENT_PATH,
  COACH_SCHEDULE_PATH,
  stripCoachFastBookOverlayParams,
} from './coach-book-student'

export const useCoachBookStudentNavigation = () => {
  const navigateToBookStudent = (history, params = {}) => {
    const { pathname, search } = history.location
    const overlayPathname =
      pathname === COACH_BOOK_STUDENT_PATH || pathname.endsWith('/book-student')
        ? COACH_SCHEDULE_PATH
        : pathname

    const cleanedSearch = stripCoachFastBookOverlayParams(search)
    history.push(
      buildCoachFastBookOverlayPath(
        overlayPathname,
        params,
        cleanedSearch ? `?${cleanedSearch}` : '',
      ),
    )
  }

  return {
    coachBookStudentPath: COACH_BOOK_STUDENT_PATH,
    navigateToBookStudent,
  }
}
